// services/historial.ts
import api from "./api";
import { getDateRangeUTC } from "./utils";
import { HistorialOperacion } from "../types";

// Registrar una compra o venta
export const registrarOperacion = async (tipo: "compra" | "venta", datos: any): Promise<HistorialOperacion> => {
  try {
    const endpoint = tipo === "compra" ? "/compras" : "/ventas";
    const response = await api.post(endpoint, datos);
    return response.data;
  } catch (error: any) {
    console.error("Error registrando la operación:", error);
    throw new Error("Error al obtener datos del servidor");
  }
};

// Eliminar una compra o venta
export const eliminarOperacion = async (tipo: "compra" | "venta", id: number): Promise<{ message: string }> => {
  try {
    const endpoint = tipo === "compra" ? `/compras/${id}` : `/ventas/${id}`;
    const response = await api.delete(endpoint);
    return response.data;
  } catch (error: any) {
    console.error("Error eliminando la operación:", error);
    throw new Error("Error al obtener datos del servidor");
  }
};


// Obtener el historial de compras o ventas
export const obtenerHistorial = async (tipo: "compra" | "venta"): Promise<HistorialOperacion[]> => {
  try {
    const endpoint = tipo === "compra" ? "/compras" : "/ventas";
    const response = await api.get(endpoint);
    return response.data;
  } catch (error: any) {
    console.error("Error obteniendo el historial:", error);
    throw new Error("Error al obtener datos del servidor");
  }
};


// Obtener historial de compras por producto
export const getComprasByProducto = async (producto_id: number): Promise<HistorialOperacion[]> => {
  try {
    const response = await api.get(`/compras/producto/${producto_id}`);
    return response.data;
  } catch (error: any) {
    console.error("Error al obtener historial de compras por producto:", error);
    throw new Error("Error al obtener datos del servidor");
  }
};

// Obtener historial de compras por proveedor
export const getComprasByProveedor = async (proveedor_id: number): Promise<HistorialOperacion[]> => {
  try {
    const response = await api.get(`/compras/proveedor/${proveedor_id}`);
    return response.data;
  } catch (error: any) {
    console.error("Error al obtener historial de compras por proveedor:", error);
    throw new Error("Error al obtener datos del servidor");
  }
};

// Obtener historial de ventas por producto
export const getVentasByProducto = async (producto_id: number): Promise<HistorialOperacion[]> => {
  try {
    const response = await api.get(`/ventas/producto/${producto_id}`);
    return response.data;
  } catch (error: any) {
    console.error("Error al obtener historial de ventas por producto:", error);
    throw new Error("Error al obtener datos del servidor");
  }
};

export const descargarExcel = async ({ fechaInicio, fechaFin, tipo }: { fechaInicio: string, fechaFin: string, tipo: 'venta' | 'compra' }): Promise<void> => {
  const endpoint = tipo === 'venta' ? '/ventas/export' : '/compras/export';
  const { fechaInicio: inicioISO, fechaFin: finISO } = getDateRangeUTC({ fechaInicio, fechaFin });
  const response = await api.get(
    `${endpoint}?fechaInicio=${inicioISO}&fechaFin=${finISO}`,
    { responseType: 'blob' }
  );
  const disposition = response.headers['content-disposition'];
  let fileName = `${tipo}s.xlsx`;
  if (disposition && disposition.indexOf('filename=') !== -1) {
    const match = disposition.match(/filename="?(.+)"?/);
    if (match && match.length > 1) fileName = match[1];
  }

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const obtenerHistorialFiltrado = async ({ tipo, fechaInicio, fechaFin }: { tipo: 'compra' | 'venta', fechaInicio: string, fechaFin: string }): Promise<HistorialOperacion[]> => {

  const { fechaInicio: inicioISO, fechaFin: finISO } = getDateRangeUTC({ fechaInicio, fechaFin })
  const endpoint = tipo === "compra" ? "/compras/filtro" : "/ventas/filtro";
  const response = await api.get(
    `${endpoint}?fechaInicio=${inicioISO}&fechaFin=${finISO}`
  );
  return response.data;
};
